export type FAQ = {
   category: string
   items: {
      question: string
      answer: string
   }[]
}

export const faq: FAQ[] = [
   {
      category: 'car-wash',
      items: [
         {
            question: 'How does the automatic car wash work?',
            answer:
               'Using our automatic car wash is simple and easy:\n1. Drive up to the entry payment terminal.\n2. Select your wash option and make payment using coins, notes, or payWave.\n3. Drive into the machine, following the green arrow, and stop when you reach the red stop light.\n4. Put your car in park or neutral, apply the handbrake, and remain inside your vehicle while the wash operates.\n5. Once the wash is complete, exit when the green arrow begins flashing.\nSit back, relax, and enjoy a hassle-free clean!'
         },
         {
            question:
               'Will my car be scratched or damaged in the wash?',
            answer:
               'No — your vehicle is safe when using our equipment, as long as you follow the instructions provided. Our systems are designed to clean effectively while being gentle on your vehicle. For the best results, simply follow the on-site guidance and signage during your wash.'
         },
         {
            question: 'Do I need to get out of the car?',
            answer:
               'No — you stay inside your vehicle for the entire wash process.'
         },
         {
            question: 'What payment methods do you accept?',
            answer:
               "Our automatic car wash accepts coins, notes, and payWave, making it quick and convenient to pay. The machines also give change, so you don't need to worry about having the exact amount."
         }
      ]
   },
   {
      category: 'self-serve-car-wash',
      items: [
         {
            question: 'How do I use the self-serve bays?',
            answer:
               "Clean Park offers a modern, all-in-one car wash facility with everything you need:\n• Two self-serve wash bays for hands-on cleaning\n• Two automatic wash machines for a quick and effortless wash\n• A dedicated dog wash to keep your furry friend fresh\n• Professional detailing services for a deeper, showroom-quality clean\nWhether you're after a quick wash or a full detail, Clean Park has everything you need in one place."
         },
         {
            question: 'What options are available?',
            answer:
               "Our self-serve bays offer a full range of wash options:\n• Pre-soak\n• Wheel cleaner / degreaser\n• High-pressure soap\n• Foam brush\n• High-pressure wax\n• Triple foam conditioner\n• Rinse\nThese options allow you to customise your wash from start to finish, whether you're doing a quick wash or a full clean."
         },
         {
            question: 'Can I bring my own cleaning products?',
            answer:
               "No — our self-serve bays are fully equipped with everything you need for a complete clean. We provide a full range of high-quality wash options and equipment, so there's no need to bring your own products."
         },
         {
            question: 'Is there a time limit?',
            answer:
               'You control the time based on your selected payment.'
         }
      ]
   },
   {
      category: 'dog-wash',
      items: [
         {
            question: 'How does the dog wash work?',
            answer:
               'Our dog wash is easy to use and fully equipped to give your pet a thorough clean:\n• Shampoo\n• Flea treatment\n• Conditioner\n• Rinse\n• Air dryer\n• Disinfectant (to clean the wash tub after use)\nSimply select your desired options and wash your dog using the hose and controls provided. Once finished, please use the disinfectant to clean the tub, ready for the next customer.'
         },
         {
            question: 'Is it suitable for all dog sizes?',
            answer:
               'Yes, the wash station is designed for small to large dogs.'
         },
         {
            question: 'Do I need to bring anything?',
            answer: 'No — everything you need is provided.'
         },
         {
            question: 'Is the water temperature controlled?',
            answer:
               'Yes, warm water is used to keep your dog comfortable.'
         },
         {
            question: 'What payment methods do you accept?',
            answer:
               'The dog wash is $10 to start and accepts coins, notes, and payWave, making it quick and convenient to use. Please note, the machine does not give change, so we recommend having the correct amount when paying with cash or use the change machine by the office.'
         },
         {
            question:
               'Is the self-serve dog wash suitable for Waikato and Morrinsville pet owners?',
            answer:
               'Yes — Clean Park Morrinsville is centrally located in Waikato at 42 Studholme Street, with 24/7 access so you can wash your dog when it suits. Many customers visit from Morrinsville, Matamata, Te Aroha, and the wider Hamilton area for a warm-water DIY wash without the mess at home.'
         }
      ]
   },
   {
      category: 'vacuum-stations',
      items: [
         {
            question: 'Are the vacuums powerful?',
            answer:
               'Yes — our vacuums are commercial-grade for strong suction and effective cleaning.'
         },
         {
            question: 'Do I need coins?',
            answer:
               'We offer convenient payment options including coins and payWave.'
         },
         {
            question: 'Can I use the vacuum without washing my car?',
            answer:
               'Absolutely — vacuum stations are available for all customers.'
         }
      ]
   },
   {
      category: 'vehicle-detailing',
      items: [
         {
            question: 'What is included in vehicle detailing?',
            answer:
               'Detailing covers a thorough clean both inside and out. Services may include:\n• Full interior vacuum and deep clean\n• Wipe-down of surfaces and high-touch areas\n• Seat and carpet cleaning\n• Hand wash and detailed exterior clean\n• Wheels, tyres, and trims\n• Protective finish products'
         },
         {
            question: 'Do you have a courtesy car available?',
            answer:
               'Yes, we have a courtesy car available for you to use while your vehicle is being detailed. Please ask at the office for more information.'
         },
         {
            question: 'Do I need to book in advance?',
            answer:
               'Yes, we recommend booking to ensure availability.'
         },
         {
            question: 'How long does detailing take?',
            answer:
               'Depending on the service, it can take a few hours to a full day.'
         },
         {
            question: "Will detailing improve my car's value?",
            answer:
               "Yes — regular detailing helps maintain and enhance your vehicle's appearance and resale value."
         },
         {
            question:
               'What grooming and detailing services do you offer for cars and larger vehicles?',
            answer:
               'Our vehicle grooming and detailing includes interior work such as full vacuum, deep clean, seat and carpet shampoo, stain removal, and water spot treatment, plus exterior hand wash, wheels and trims, cut and polish, paint correction, engine bay cleaning, and protective products. We can also discuss tractors, RVs, boats, and other large vehicles by appointment — contact Clean Park Morrinsville on 07 889 6823 to book.'
         }
      ]
   },
   {
      category: 'fleet',
      items: [
         {
            question: 'What is a fleet wash account at Clean Park Morrinsville?',
            answer:
               'A fleet account lets your New Zealand business put multiple vehicles on one Clean Park account. Each vehicle gets its own wash tag, you can choose which wash types each tag can access (such as self-serve bays, automatic wash, or vacuums), and you receive a single monthly invoice instead of paying per visit at the machine.'
         },
         {
            question:
               'Which vehicles can go on a Waikato fleet wash account?',
            answer:
               'Fleet accounts suit company cars, tradie utes, vans, service vehicles, farm vehicles, and other work fleets. Tags are configured per vehicle so drivers only use the services you allow. Contact us to discuss your fleet size and the best setup for your business in Morrinsville and the wider Waikato region.'
         },
         {
            question: 'How do we set up or manage a fleet wash account?',
            answer:
               'Call Clean Park Morrinsville on 07 889 6823 or visit 42 Studholme Street. We set up your account, add vehicles, issue wash tags, and arrange monthly invoicing. You can adjust which wash options each tag unlocks as your needs change.'
         }
      ]
   },
   {
      category: 'general-questions',
      items: [
         {
            question: 'Where are you located?',
            answer:
               'Clean Park Morrinsville is conveniently located at 42 Studholme Street, Morrinsville. We are easy to find and centrally positioned, making it simple to stop in whether you are heading through town or live locally. Look out for our signage and modern wash bays when you arrive.'
         },
         {
            question: 'What are your opening hours?',
            answer:
               'Our self-serve wash bays, automatic wash machines, and dog wash are open 24 hours a day, 7 days a week, so you can clean your vehicle whenever it suits you. Our detailing services are available by appointment, ensuring we can provide the best care and attention for your vehicle.'
         },
         {
            question: 'Is Clean Park suitable for all vehicle types?',
            answer:
               'Yes — Clean Park caters for a wide range of vehicles including cars, vans, motorhomes, tractors, and motorbikes. Our automatic wash machines have different height clearances:\n• Auto wash 1: up to 2.8m height\n• Auto wash 2: up to 2.3m height\nOur self-serve wash bays offer even greater flexibility, with a clearance of up to 4.2m, making them ideal for larger vehicles and equipment.'
         }
      ]
   }
]
